<template src="@/components/collections/templates/PaymentTemplate.html">
</template>
<script type="text/javascript">
import { mapGetters } from "vuex"
import PaymentMixin from "@/mixins/payment-mixin"
import CartFixed from "@/components/modules/hosted-pages/CartFixed"
import PaymentComponent from "@/components/modules/hosted-pages/PaymentComponent"
import CBNotification from "@/models/cb-notification"
import Notes from "@/components/collections/elements/Notes"
import LazyLoadPaymentComponents from '@/components/modules/hosted-pages/LazyLoadPaymentComponents'

export default {
  mounted(){
    if(this.get_form_temp('pm_type')) {
      this.payment_method_type = this.get_form_temp('pm_type');
      this.$store.dispatch('delete_form_temp',  'pm_type');
    } else {
      this.payment_method_type = this.editMode && this.selected_payment_method ? this.selected_payment_method.type : this.pm_list[0] && this.pm_list[0].type;
      if(!this.payment_method_type) {
        this.$store.dispatch('set_current_notification', new CBNotification('error', {message: this.st('gateway_error')}));
      }
    }
  },
  mixins: [PaymentMixin],
  computed: {
    ...mapGetters([
      'skip_cart',
      'current_error_source',
      'pm_authorized',
      'is_checkout_existing',
      'hasTrialPeriod',
      'plan_placeholder',
      'selected_payment_method',
      'get_form_temp',
      'one_screen_checkout'
    ]),
    buttonTxt() {
      if (this.$route.query.mode == "empty") {
        return this.$store.getters.translate(`${this.$route.name}.update`)
      }
      return this.editMode ? this.$store.getters.translate(`${this.$route.name}.update`) : this.$store.getters.translate(`${this.$route.name}.next`);
    },
    useBillingInfo() {
      return this.$store.getters.field_config("card", "card.copy_billing_info") && this.$store.getters.field_config("card", "card.copy_billing_info").value;
    },

    useShippingInfo() {
      return this.$store.getters.field_config("card", "card.copy_shipping_info") && this.$store.getters.field_config("card", "card.copy_shipping_info").value;
    },

    paymentNote() {
      if(this.hasTrialPeriod){
        return this.t('payment_method.note.plan.trial', this.plan_placeholder);
      }
      return this.t('payment_method.note.plan.no_trial', this.plan_placeholder);
    },
    threedsNote() {
      if(this.one_screen_checkout) {
        return this.hasTrialPeriod ? this.t('review.threedsWarning.trial') : this.t('review.threedsWarning.non_trial');
      }
    }

  },
  data() {
    return {
      payment_method_type: undefined,
      showLoader: false,
      swapPaymentMethod : true,
    }
  },
  props: ['editMode', 'subscribeMode'],
  methods: {
    submit() {
      if(this.recaptchaVerification && window.grecaptcha) {
        grecaptcha.execute();
      } else {
        this.proceed();
      }
    },
    proceed() {
      this.subscribeMode ? this.subscribe() : this.submitForCheckout();
    },
    setPaymentType($event){
      this.payment_method_type = $event;
    },
    _displayErrorMessage() {
      let error = this.current_error_source;
      if(!this.current_error_source) {
        return;
      }
      if(error.isParamException && error.isParamException()){
        if(this.payment_method_type == "card") {
          this.$store.dispatch('set_error', {name: error.paramName, fname: "card",
            error: error.paramMessage
          });
        }
      }
    },
    renderRecaptcha() {
      window.cbTimeout(() => {
        this._renderRecaptcha();
      }, 500);
    }
  },
  components: {
    'card-section': LazyLoadPaymentComponents.CheckoutCardSection,
    'paypal-section': LazyLoadPaymentComponents.PaypalSection,
    'direct-debit-section': LazyLoadPaymentComponents.DirectDebitSection,
    'amazon-payment-section':  LazyLoadPaymentComponents.AmazonPaymentSection,
    'apple-pay-section': LazyLoadPaymentComponents.ApplePaySection,
    'cart-fixed': CartFixed,
    'payment-component' : PaymentComponent,
    'cb-notes': Notes
  }
}
</script>



// WEBPACK FOOTER //
// PaymentSection.vue?2d76fae1